import { render, staticRenderFns } from "./SupersetDashboard.vue?vue&type=template&id=22ed216c&scoped=true"
import script from "./SupersetDashboard.vue?vue&type=script&lang=js"
export * from "./SupersetDashboard.vue?vue&type=script&lang=js"
import style0 from "./SupersetDashboard.vue?vue&type=style&index=0&id=22ed216c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ed216c",
  null
  
)

export default component.exports